/**
 * Instructions model
 */
export class Instructions {
  constructor(public name: string, public steps: string[]) {}
}
